export const messages = {
  en: {
    mainCategoryProduct: {
      queryCondition: 'Query Conditions',
      inputName: 'Please enter name',
      query: 'Query',
      specialProduct: 'Special Products',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      cancel: 'Cancel',
      save: 'Save',
      all: 'All',
      category: 'Category',
      code: 'Code',
      name: 'Name',
      startTime: 'Start Time',
      endTime: 'End Time',
      sort: 'Sort',
      operation: 'Operation',
      confirmOperation: 'Please confirm your operation',
      confirmDeleteProduct: 'Confirm to delete category product?',
      confirmDelete: 'Confirm Delete',
      deleteSuccess: 'Delete successfully',
      editSuccess: 'Edit successfully',
      addSuccess: 'Add successfully',
      selectCategory: 'Required, please select category',
      productCode: 'Product Code',
      inputProductCode: 'Required, please enter product code',
      productCodeTip: 'Copy product ID from merchant category product page',
      selectStartTime: 'Required, please select start time',
      selectEndTime: 'Required, please select end time',
      inputSort: 'Required, please enter sort number',
      categoryRequired: 'Category is required',
      productCodeRequired: 'Product code is required',
      productCodeMaxLength: 'Product code is too long',
      startTimeRequired: 'Start time is required',
      endTimeRequired: 'End time is required',
      sortRequired: 'Sort is required',
      sortMustNumber: 'Sort must be number',
      idRequired: 'ID is required'
    }
  },
  zh: {
    mainCategoryProduct: {
      queryCondition: '查询条件',
      inputName: '请输入名称',
      query: '查询',
      specialProduct: '专区商品',
      add: '添加',
      edit: '修改',
      delete: '删除',
      cancel: '取消',
      save: '保存',
      all: '全部',
      category: '目录',
      code: '编号',
      name: '名称',
      startTime: '开始时间',
      endTime: '结束时间',
      sort: '排序',
      operation: '操作',
      confirmOperation: '请确认您的操作',
      confirmDeleteProduct: '确定删除目录商品？',
      confirmDelete: '确认删除',
      deleteSuccess: '删除成功',
      editSuccess: '修改成功',
      addSuccess: '添加成功',
      selectCategory: '必填，请选择目录',
      productCode: '商品编号',
      inputProductCode: '必填，请填写商品编号',
      productCodeTip: '商家目录下的上架商品页面，复制商品ID',
      selectStartTime: '必填，请填写开始时间',
      selectEndTime: '必填，请填写结束时间',
      inputSort: '必填，请填写排序',
      categoryRequired: '目录不能为空',
      productCodeRequired: '商品编号不能为空',
      productCodeMaxLength: '商品编号太长',
      startTimeRequired: '开始时间不能为空',
      endTimeRequired: '结束时间不能为空',
      sortRequired: '排序不能为空',
      sortMustNumber: '排序必须是整数',
      idRequired: '主键不能为空'
    }
  }
}